import React, { useState } from "react";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import TabPanel from "../../elements/tab/materialTabPanel";
import TransferPaymentContainer from "./TransferPaymentContainer";
import TransferPayoutContainer from "./TransferPayoutContainer";
import queryString from "query-string";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { StyledTabsHead } from "../../styles/styledTabs";

const DEFAULT_TAB = "payment-transfers";

const TransferTabsContainer = ({ match, refetch, setRefetch }) => {
  const { t } = useTranslation("transferPage");

  const history = useHistory();
  let queryParams = queryString.parse(history.location.search);

  const urlForTabs = () => {
    if (!queryParams.currentTab) {
      return 0;
    }

    switch (queryParams.currentTab) {
      case "payment-transfers": {
        return 0;
      }
      case "payout-transfers": {
        return 1;
      }
    }
  };

  const tabValue = urlForTabs();

  const handleChange = (event, newValue) => {
    if (queryParams.currentTab !== newValue) {
      history.push("?currentTab=" + newValue);
    }
  };

  return (
    <>
      <StyledTabsHead
        className="tab-head"
        orientation="horizontal"
      >
        <Tabs
          value={queryParams?.currentTab ?? DEFAULT_TAB}
          indicatorColor="secondary"
          onChange={handleChange}
          orientation="horizontal"
          className="tab-head-buttons"
        >
          <Tab label={t("tabs.paymentTransfer")} value="payment-transfers" />
          <Tab label={t("tabs.payoutTransfer")} value="payout-transfers" />
        </Tabs>
      </StyledTabsHead>
      <TabPanel
        value={tabValue}
        index={0}
      >
        <TransferPaymentContainer refetch={refetch} setRefetch={setRefetch} />
      </TabPanel>
      <TabPanel
        value={tabValue}
        index={1}
      >
        <TransferPayoutContainer refetch={refetch} setRefetch={setRefetch} />
      </TabPanel>
    </>
  );
};

export default TransferTabsContainer;